import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { isFetching } from 'utils/redux/fetching'
import { fetchAllocations, fetchLuckyAllocations, fetchReligions, fetchStates, fetchPoliticalAffiliations, fetchEthnicities } from 'redux/actions/actions'
import { markLuckyAllocations } from 'redux/actions/actions'
import View from '../components/View'
import Loader from 'components/Loader'
import moment from 'moment-timezone'

class Allocations extends React.Component {

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchAllocations())
		dispatch(fetchLuckyAllocations())
		dispatch(fetchReligions())
		dispatch(fetchStates())
		dispatch(fetchPoliticalAffiliations())
		dispatch(fetchEthnicities())
	}

	render () {
		if (this.props.isFetching) return <Loader />

		return <View {...this.props} />
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		dispatch,
		markAsLucky: data => dispatch(markLuckyAllocations(data))
	}
}

const buildAllocationsData = (allocation, religions, states, politicalAffiliations, ethnicities) => {

	const { _id, type, amountToSelf, amountToOther, creator, receiver, reviewedSurveyInfo } = allocation
	const { survey } = creator

	return {
		id: _id,
		type,
		status: allocation.status,
		dateOfCreation: moment(allocation.createdAt).tz('America/Los_Angeles').format('DD/MM/YYYY, h:mm:ss a z'),
		dateOfCompletion: allocation.dateOfCompletion ? moment(allocation.dateOfCompletion).tz('America/Los_Angeles').format('DD/MM/YYYY, h:mm:ss a z') : 'Not completed yet',
		amountToSelf: amountToSelf ? '$' + amountToSelf : null,
		amountToOther: amountToOther ? '$' + amountToOther : null,
		allocationBy: creator.name + ' ' + creator.email,
		creatorGender: survey.gender,
		creatorAge: survey.age,
		creatorCity: survey.city,
		creatorState: states.byIds[survey.state] ? states.byIds[survey.state].name : null,
		creatorIsMarried: survey.isMarried === false
			? 'No'
			: survey.isMarried && 'Yes',
		creatorHasChildren: survey.hasChildren === false
			? 'No'
			: survey.hasChildren && 'Yes',
		creatorEthnicity: ethnicities.byIds[survey.ethnicity] ? ethnicities.byIds[survey.ethnicity].name : null,
		creatorReligion: religions.byIds[survey.religion] ? religions.byIds[survey.religion].name : null,
		creatorPoliticalAffiliations: politicalAffiliations.byIds[survey.politicalAffiliation] ? politicalAffiliations.byIds[survey.politicalAffiliation].name : null,
		allocationTo: receiver.name + ' ' + receiver.email,
		receiverGender: reviewedSurveyInfo.gender,
		receiverAge: reviewedSurveyInfo.age,
		receiverCity: reviewedSurveyInfo.city,
		receiverState: reviewedSurveyInfo.state && states.byIds[reviewedSurveyInfo.state] ? states.byIds[reviewedSurveyInfo.state].name : null,
		receiverIsMarried: reviewedSurveyInfo.isMarried === false
			? 'No'
			: reviewedSurveyInfo.isMarried && 'Yes',
		receiverHasChildren: reviewedSurveyInfo.hasChildren === false
			? 'No'
			: reviewedSurveyInfo.hasChildren && 'Yes',
		receiverEthnicity: reviewedSurveyInfo.ethnicity && ethnicities.byIds[reviewedSurveyInfo.ethnicity] ? ethnicities.byIds[reviewedSurveyInfo.ethnicity].name : null,
		receiverReligion: reviewedSurveyInfo.religion && religions.byIds[reviewedSurveyInfo.religion] ? religions.byIds[reviewedSurveyInfo.religion].name : null,
		receiverPoliticalAffiliations: reviewedSurveyInfo.politicalAffiliation && politicalAffiliations.byIds[reviewedSurveyInfo.politicalAffiliation] ? politicalAffiliations.byIds[reviewedSurveyInfo.politicalAffiliation].name : null
	}
}

const mapStateToProps = state => {

	if (isFetching([
		state.allocations,
		state.luckyAllocations,
		state.religions,
		state.states,
		state.politicalAffiliations,
		state.ethnicities
	])) return { isFetching: true }

	const allocations = []
	for (let key in state.allocations.byIds) {
		allocations.push(buildAllocationsData(
			state.allocations.byIds[key],
			state.religions,
			state.states,
			state.politicalAffiliations,
			state.ethnicities
		))
	}

	const luckyAllocations = []
	for (let key in state.luckyAllocations.byIds) {
		luckyAllocations.push(buildAllocationsData(
			state.luckyAllocations.byIds[key],
			state.religions,
			state.states,
			state.politicalAffiliations,
			state.ethnicities
		))
	}

	const startTime = moment('6:00am', 'h:mma').tz('America/Los_Angeles') // 8pm PT
	const endTime = moment('7:00am', 'h:mma').tz('America/Los_Angeles')   // 9pm PT
	const now = moment().tz('America/Los_Angeles')
	const day = now.day()

	return {
		all: allocations,
		real: allocations.filter(allocation => allocation.type === 'REAL'),
		lucky: luckyAllocations,
		// Btn is enabled only on Sunday between 8pm and 9pm
		isBtnDisabled: day !== 7 && !moment(now).isBetween(startTime, endTime)
	}
}

Allocations.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(Allocations)



// WEBPACK FOOTER //
// ./src/routes/Allocations/containers/Allocations.js